<app-navbar></app-navbar>
<div [@routeToLoginWithAnimation]="routeWithAnimation()" >
    <router-outlet></router-outlet>
</div>